var map = {
	"./CatalogCarousel/CatalogCarousel.vue": [
		1178,
		167
	],
	"./CatalogCarousel/CatalogItem.vue": [
		1171,
		246
	],
	"./MarketingCards.vue": [
		319
	],
	"./ProductCarousel/CarouselProductItem.vue": [
		1172,
		247
	],
	"./ProductCarousel/ProductCarousel.vue": [
		1179,
		6,
		112
	],
	"./ReorderHighlight/ReorderHighlight.vue": [
		1180,
		171
	],
	"./VoucherCarousel/VoucherCardItem.vue": [
		401
	],
	"./VoucherCarousel/VoucherCarousel.vue": [
		397
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1148;
module.exports = webpackAsyncContext;